import { useEffect, useState } from 'react'
import api from '../services/api'

interface NaoConformidadeItem {
  ncocod: number
  ncodes: string
  ncopts: number
}

interface NaoConformidadeDetalhe {
  ncocod: number
  ncodes: string
  ncopts: number
}

const NOVA_NAO_CONFORMIDADE: NaoConformidadeDetalhe = {
  ncocod: 0,
  ncodes: '',
  ncopts: 0,
}

function Campo({ label, width, children }: { label: string; width?: number | string; children: React.ReactNode }) {
  return (
    <div className="field-cad" style={{ width }}>
      <label style={{ display: 'block', minHeight: '1.1rem', lineHeight: 1.2 }}>{label}</label>
      {children}
    </div>
  )
}

export default function NaoConformidades() {
  const [lista, setLista] = useState<NaoConformidadeItem[]>([])
  const [busca, setBusca] = useState('')
  const [carregandoLista, setCarregandoLista] = useState(false)
  const [selecionado, setSelecionado] = useState<NaoConformidadeDetalhe | null>(null)
  const [carregandoDetalhe, setCarregandoDetalhe] = useState(false)
  const [modoCriar, setModoCriar] = useState(false)
  const [form, setForm] = useState<NaoConformidadeDetalhe | null>(null)
  const [salvando, setSalvando] = useState(false)
  const [msgSalvar, setMsgSalvar] = useState<{ texto: string; ok: boolean } | null>(null)

  async function carregarLista(termo: string) {
    setCarregandoLista(true)
    try {
      const r = await api.get('/nao-conformidades', { params: termo ? { busca: termo } : {} })
      setLista(r.data)
    } finally {
      setCarregandoLista(false)
    }
  }

  useEffect(() => { carregarLista('') }, [])
  useEffect(() => {
    const t = setTimeout(() => carregarLista(busca), 350)
    return () => clearTimeout(t)
  }, [busca])

  async function selecionar(cod: number) {
    setCarregandoDetalhe(true)
    setModoCriar(false)
    setMsgSalvar(null)
    try {
      const r = await api.get(`/nao-conformidades/${cod}`)
      setSelecionado(r.data)
      setForm(r.data)
    } finally {
      setCarregandoDetalhe(false)
    }
  }

  function nova() {
    setSelecionado(null)
    setModoCriar(true)
    setForm({ ...NOVA_NAO_CONFORMIDADE })
    setMsgSalvar(null)
  }

  function setCampo<K extends keyof NaoConformidadeDetalhe>(campo: K, valor: NaoConformidadeDetalhe[K]) {
    setForm(f => f && { ...f, [campo]: valor })
  }

  async function salvar() {
    if (!form) return
    setSalvando(true)
    setMsgSalvar(null)
    try {
      if (modoCriar) {
        const r = await api.post('/nao-conformidades', form)
        setMsgSalvar({ texto: 'Não conformidade criada com sucesso.', ok: true })
        setModoCriar(false)
        await selecionar(r.data.ncocod)
      } else if (selecionado) {
        await api.put(`/nao-conformidades/${selecionado.ncocod}`, form)
        setMsgSalvar({ texto: 'Alterações salvas com sucesso.', ok: true })
        await selecionar(selecionado.ncocod)
      }
      await carregarLista(busca)
    } catch (e: any) {
      setMsgSalvar({ texto: e?.response?.data?.error || 'Erro ao salvar.', ok: false })
    } finally {
      setSalvando(false)
    }
  }

  return (
    <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
      {/* Lista */}
      <div className="card" style={{ width: 320, flexShrink: 0 }}>
        <h3 style={{
          fontSize: '1rem', fontWeight: 700, marginBottom: '0.9rem', color: '#1a6ea8',
          paddingBottom: '0.6rem', borderBottom: '2px solid #eff6ff',
        }}>
          Não Conformidades
        </h3>

        <div style={{ display: 'flex', gap: 8, marginBottom: '0.75rem', alignItems: 'center' }}>
          <div className="field" style={{ flex: 1 }}>
            <input
              type="text"
              placeholder="Código ou descrição..."
              value={busca}
              onChange={e => setBusca(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-sm" onClick={nova} title="Nova não conformidade">+ Nova</button>
        </div>

        {carregandoLista && <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Carregando...</p>}
        {!carregandoLista && lista.length === 0 && (
          <p style={{ color: '#6b7280', fontSize: '0.85rem' }}>Nenhuma não conformidade encontrada.</p>
        )}

        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 560, overflowY: 'auto' }}>
          {lista.map(n => {
            const ativo = selecionado?.ncocod === n.ncocod
            return (
              <button
                key={n.ncocod}
                onClick={() => selecionar(n.ncocod)}
                style={{
                  textAlign: 'left', border: '1px solid #e5e7eb', borderLeft: '4px solid #1a6ea8',
                  borderRadius: 6, padding: '8px 10px', cursor: 'pointer',
                  background: ativo ? '#eff6ff' : '#f8fafc',
                  borderColor: ativo ? '#1a6ea8' : '#e5e7eb',
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span style={{ fontWeight: 700, fontSize: '0.82rem' }}>{n.ncocod}</span>
                  <span style={{ fontSize: '0.72rem', color: '#9ca3af' }}>{n.ncopts} pts</span>
                </div>
                <div style={{ fontSize: '0.8rem', color: '#374151', marginTop: 3 }}>{n.ncodes}</div>
              </button>
            )
          })}
        </div>
      </div>

      {/* Detalhe */}
      <div className="card" style={{ flex: 1, minWidth: 0 }}>
        {!selecionado && !modoCriar && !carregandoDetalhe && (
          <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>
            Selecione uma não conformidade na lista ao lado, ou clique em "+ Nova".
          </p>
        )}

        {carregandoDetalhe && <p style={{ color: '#6b7280', fontSize: '0.9rem' }}>Carregando detalhes...</p>}

        {(selecionado || modoCriar) && form && !carregandoDetalhe && (
          <>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
              marginBottom: '0.6rem', paddingBottom: '0.5rem', borderBottom: '2px solid #eff6ff',
            }}>
              <h3 style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a6ea8' }}>
                {modoCriar ? 'Nova Não Conformidade' : `${selecionado?.ncocod} — ${selecionado?.ncodes}`}
              </h3>
            </div>

            <div style={{
              background: '#f7faff', border: '1px solid #eef0f4', borderLeft: '4px solid #1a6ea8',
              borderRadius: '0.5rem', padding: '0.55rem 0.85rem', marginBottom: '0.55rem',
              display: 'flex', flexWrap: 'wrap', gap: '0.4rem 0.8rem', alignItems: 'flex-end',
            }}>
              <Campo label="Código" width={95}>
                {modoCriar ? (
                  <input type="number" value={form.ncocod || ''}
                    onChange={e => setCampo('ncocod', Number(e.target.value))} />
                ) : (
                  <input type="text" value={selecionado?.ncocod ?? ''} readOnly disabled />
                )}
              </Campo>
              <Campo label="Descrição" width={300}>
                <input type="text" maxLength={30} value={form.ncodes} onChange={e => setCampo('ncodes', e.target.value)} />
              </Campo>
              <Campo label="Pontos" width={95}>
                <input type="number" value={form.ncopts}
                  onChange={e => setCampo('ncopts', e.target.value === '' ? 0 : Number(e.target.value))} />
              </Campo>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <button className="btn btn-primary" onClick={salvar} disabled={salvando}>
                {salvando ? 'Salvando...' : modoCriar ? 'Criar' : 'Salvar alterações'}
              </button>
              {msgSalvar && (
                <span style={{
                  fontSize: '0.8rem', fontWeight: 600, padding: '0.35rem 0.8rem', borderRadius: 6,
                  background: msgSalvar.ok ? '#d1fae5' : '#fee2e2',
                  color: msgSalvar.ok ? '#065f46' : '#991b1b',
                }}>
                  {msgSalvar.texto}
                </span>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
